/**
 * Global ECharts side effects for production bundles.
 * Registers LabelLayout and keeps format utils from tree-shaking.
 * Also installs tooltip-hide-on-leave and pointer-fixed body tip placement.
 */
import { format, registerPostInit, use } from 'echarts/core'
import { LabelLayout } from 'echarts/features'

import { installHideEchartsTooltipOnLeave } from '@/utils/echartsTooltipHide.js'
import { installEchartsTooltipPointerPosition } from '@/utils/echartsTooltipPointerPosition.js'

use([LabelLayout])
format.encodeHTML('')
installHideEchartsTooltipOnLeave(registerPostInit)
installEchartsTooltipPointerPosition(registerPostInit)
